// Build a user-facing error string from a parsed JSON body returned
// by a non-2xx response. Prefers the backend's `message` field; falls
// back to the full body or status text. Existing call sites used
// JSON.stringify(errorBody) which dumped the full envelope into toasts
// — this pulls the readable bit out instead.
export function formatApiError(
  errorBody: unknown,
  status: number,
  statusText: string,
): string {
  if (errorBody && typeof errorBody === "object") {
    const body = errorBody as Record<string, unknown>;
    if (typeof body.message === "string" && body.message.length > 0) {
      return body.message;
    }
  }
  if (typeof errorBody === "string" && errorBody.length > 0) {
    return errorBody;
  }
  if (errorBody) {
    try {
      return JSON.stringify(errorBody);
    } catch {
      // fall through
    }
  }
  return `${status} ${statusText}`;
}
